import { schema } from 'normalizr';

export const fieldSchema = new schema.Entity('field', {}, { idAttribute: '_id' });
export const fieldListSchema = [fieldSchema];
